import * as THREE from 'three';
import { BinaryAtlas } from './BinaryAtlas.js';
import { BINARY_DEFAULTS } from './binaryConfig.js';

/** @type {BinaryAtlas | null} */
let sharedAtlas = null;

/** Single atlas texture shared by city + NPC binary materials. */
export function getSharedBinaryAtlas() {
  if (!sharedAtlas) {
    sharedAtlas = new BinaryAtlas({
      pixelSize: BINARY_DEFAULTS.atlasPixelSize,
    });
  }
  return sharedAtlas;
}

export function disposeSharedBinaryAtlas() {
  sharedAtlas?.dispose();
  sharedAtlas = null;
}
